import {GlobalExternalLinkEnum, ProductEnum} from 'presentation/constants';
import {useHostName} from 'presentation/hooks';

export function useWatchTutorial() {
	const {
		dataHostNameState: {product},
	} = useHostName();

	const telehealthTutorial: Record<ProductEnum, GlobalExternalLinkEnum> = {
		[ProductEnum.HAP]: GlobalExternalLinkEnum.TELEHEALTH_TUTORIAL_HAP,
		[ProductEnum.CCG]: GlobalExternalLinkEnum.TELEHEALTH_TUTORIAL_CCG,
		[ProductEnum.CLINIPAM]: GlobalExternalLinkEnum.TELEHEALTH_TUTORIAL_CLINIPAM,
		[ProductEnum.GNDI_MINAS]: GlobalExternalLinkEnum.TELEHEALTH_TUTORIAL_GNDI_MINAS,
		[ProductEnum.GNDI]: GlobalExternalLinkEnum.TELEHEALTH_TUTORIAL_GNDI_SP,
		[ProductEnum.NOTREDAME_SAUDE]: GlobalExternalLinkEnum.TELEHEALTH_TUTORIAL_GNDI_SP,
	};

	const tutorialLink = telehealthTutorial[product];

	function handleWatchTutorial() {
		window.open(tutorialLink);
	}

	return {handleWatchTutorial, tutorialLink};
}
